import { Injectable, signal } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  public text = signal<string | undefined>(undefined);

  constructor(
    private spinner: NgxSpinnerService
  ) { }


  public show(text?: string){
    this.text.set(text);
    this.spinner.show();
  }

  public hide(){
    this.spinner.hide();
  }


}
